<template>
  <div class="checkout-builder-backgroud-image px-6">
    <snow-input-file isImage isFluid v-model="image" @input="saveBackground" />
  </div>
</template>

<script>
export default {
  computed: {
    image: {
      get() {
        return this.$store.state.checkoutBuilder?.background?.image;
      },
      set(v) {
        this.$store.commit("checkoutBuilder/setBackground", {
          image: v,
          color: ""
        });
      }
    }
  },
  methods: {
    saveBackground() {
      this.$store.dispatch("checkoutBuilder/saveSnapshot");
    }
  }
};
</script>
